export function homeIncrement(increment) {
  return {
    type: 'HOME_COUNTER',
    increment
  };
}

export function allHomeImagesLoaded(bool) {
  return {
    type: 'ALL_HOME_IMAGES_LOADED',
    allLoaded: bool
  };
}

const homeIncrementTrigger = (limit, imgCount) => {
  return (dispatch, getState) => {
    const imageLoaded = () => {
      if (getState().homeCounter + limit <= (imgCount - 5)) {
        return limit = getState().homeCounter + limit;
      } else {
        dispatch(allHomeImagesLoaded(true));
        return limit = imgCount;
      }
    };
    dispatch(homeIncrement(imageLoaded()));
  };
};

export default homeIncrementTrigger;



// WEBPACK FOOTER //
// ./src/redux/actions/home_counter.js